import { Molecule, Wrapper } from "AppReact";
import styled from "styled-components";
import { SecondaryTextSmBold } from "atoms";
import { Icon } from "../atoms";
import { StarSvg } from "components/icons";

const template = styled.div`
  cursor: pointer;
`;

export default Molecule({
  template,
  type: "button",
  atoms: [
    {
      wrapper: Wrapper(
        styled.div`
          display: flex;
          gap: 10px;
          align-items: center;
        `
      ),
      name: "Wrapper",
      atoms: [
        {
          component: SecondaryTextSmBold,
          name: "Label",
          displayValue: ({ label }) => label ?? "",
        },
        {
          component: Icon,
          name: "Icon",
          displayValue: ({ featured }) =>
            StarSvg({ width: 20, height: 20, filled: featured }),
        },
      ],
    },
  ],
});
